import flattenDeep from 'lodash/flattenDeep'

export const allTradeshowBrandsData = (response) => {
  const formattedData = flattenDeep(
    response.tradeShow.edges.map(({ node: tradeshow }) =>
      tradeshow.tradeShowBrands.edges.map(({ node: brand }) => ({
        id: brand.brandId,
        mainImage: brand.mainImage,
        name: brand.name,
        slug: brand.slug,
        eventSlug: tradeshow.slug,
      })),
    ),
  )

  return formattedData
}
